const config = {
  rowSelection: false,
  columns: [
    {
      dataIndex: 'id',
      hidden: true,
    },
    {
      title: '模板名称',
      dataIndex: 'name',
      fixed: 'left',
      width: 150,
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 300,
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      width: 200,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 200,
    },
    {
      title: '状态',
      dataIndex: 'enable',
      width: 100,
      render: 'switchRender',
    },
    {
      title: '操作',
      render: 'actionTool',
      fixed: 'right',
      width: 210,
    },
  ],
  search: [
    {
      name: 'name',
      label: '模板名称',
    },
  ],
  footer: [
    {
      label: '新增模板',
      //   auth: 'warehousingClueExportBtn',
      type: 'primary',
      events: ['onClick:addTemplate'],
    },
  ],
}

export default config
